import styled from '@emotion/styled'

export const ConsolidatedBillingSwitchFormItemWrapper = styled.div`
  width: 45px;
`
